import { Component } from "react";
import propTypes from "prop-types";
import firebase from "firebase/app";
import "firebase/database";

export const METHODS = {
  SET: "set",
  ON: "on",
  ONCE: "once"
};

const EVENTS = {
  VALUE: "value"
};

function getFbRef(path) {
  return firebase.database().ref(path);
}

function fbSet(ref, data) {
  return ref.set(data);
}

function fbOn(ref) {
  return new Promise((resolve, reject) =>
    ref.on(EVENTS.VALUE, resolve, reject)
  );
}

function fbOnce(ref) {
  return ref.once(EVENTS.VALUE);
}

export default class Firebase extends Component {
  state = {
    response: null,
    error: null,
    pending: true
  };

  fbRef = null;

  componentDidMount() {
    const { refPath, method, data } = this.props;
    this.fbRef = getFbRef(refPath);
    switch (method) {
      case METHODS.ON:
        fbOn(this.fbRef)
          .then((snapshot) =>
            this.setState({ response: snapshot, pending: false })
          )
          .catch((error) => this.setState({ error, pending: false }));
        break;
      case METHODS.SET:
        fbSet(this.fbRef, data)
          .then(() => {
            let response = "ok";
            this.setState({ response, pending: false });
          })
          .catch((error) => this.setState({ error, pending: false }));
        break;
      case METHODS.ONCE:
        fbOnce(this.fbRef)
          .then((snapshot) =>
            this.setState({ response: snapshot, pending: false })
          )
          .catch((error) => this.setState({ error, pending: false }));
        break;

      default:
        break;
    }
  }

  componentWillUnmount() {
    this.fbRef.off();
  }

  render() {
    const { renderSuccess, renderPending, renderError } = this.props;
    const { response, error, pending } = this.state;
    if (pending) {
      return renderPending();
    } else if (response) {
      return renderSuccess(response);
    } else {
      return renderError(error);
    }
  }
}

Firebase.propTypes = {
  refPath: propTypes.string.isRequired,
  method: propTypes.oneOf(Object.values(METHODS)).isRequired,
  data: propTypes.object,
  renderSuccess: propTypes.func.isRequired,
  renderPending: propTypes.func.isRequired,
  renderError: propTypes.func.isRequired
};
